<template>
  <div id="app">
    <transition name="fade">
      <Preloader v-if="isLoading" />
    </transition>

    <Navbar
      :offset-top="navOffsetTop"
      :logoUrl="siteInfo.logoUrl"
      :nav-links="siteInfo.navLinks"
    />
    <router-view />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar/Navbar.vue";
import Preloader from "@/components/Preloader/Preloader.vue";
import easyScroll from "easy-scroll";
export default {
  name: "App",
  metaInfo() {
    return {
      title: "PWA - Technology Solutions",
      meta: [
        {
          name: "description",
          content:
            "We provide enterprise business technology solutions and managed services that connect insight, innovation and expertise in Microsoft technologies to help customers realize results.",
        },
        { property: "og:title", content: "PWA - Technology Solutions" },
        {
          property: "og:description",
          content:
            "We provides enterprise business technology solutions and managed services that connect insight, innovation and expertise in Microsoft technologies to help customers realize results.",
        },
        { property: "og:site_name", content: "PWA" },
        { property: "og:image", content: "https://pwa.com.do/logo_gnl.png" },
        { property: "og:url", content: "http://pwa.com.do/" },

        { name: "twitter:card", content: "description" },
        { name: "twitter:title", content: "PWA - Technology Solutions" },
        {
          name: "twitter:description",
          content:
            "We provides enterprise business technology solutions and managed services that connect insight, innovation and expertise in Microsoft technologies to help customers realize results.",
        },
        { name: "twitter:image", content: "https://pwa.com.do/logo_gnl.png" },
        { name: "twitter:site", content: "@pwa_rd" },
        { name: "twitter:creator", content: "@pwa_rd" },

        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
        {
          name: "keywords",
          content:
            "P.W.A,Azure,Nube,Desarrollo,Software,.NET,Servicios Desarrollo,Transformación Digital,transformación digital empresa,desarrollo de software,Digital Transformation,Software Development,Tecnology Solutions,Soluciones tecnologicas,Empresa de tecnologia en Republica Dominicana,Empresa de TI,Empresa de IT,TI,IT,Continuidad del negocio,Business,Productivity,Data,soluciones tecnologicas de software,virtualizacion informatica,Virtualizacion en la Nube,Remoto,Virtualization,Infraestructur,Automatization,Data Center,Power Bi,office 365,office365,Correos de empresas,Microsoft office 365,Aplicacion movil,Aplicación móvil,Gestion de proyectos,que es innovacion,que es la nube,Correos electronicos de empresas,administracion de proyectos,almacenamiento en la nube,azure portal,Microsoft Azure,computacion en la nube,microsoft windows 10,que es la nube informatica,sistema software,plataforma office 365,curso de excel avanzado,windows server,windows server 2012,windows server 2016,windows 365,como crear una app,como crear una aplicacion,pagina web,Sistema de gestion,gestion de contenido web,aplicaciones web,app movil,desarrollo de apps,aplicaciones para celulares,diseño de software,aplicaciones para android,desarrollo de aplicaciones moviles,crear aplicaciones android,empresas de desarrollo de software,programas para programar,que es cloud,Big Data,SQL Sever,sql server,Business inteligence,Data mining,data analytics,centro de datos,fotos de nubes,microsoft sql,big data analytics,programas de base de datos,Virtual Desktop,Sistema Web,ms sql server,what is big data,analysis services,software de aplicacion,phone,software de programacion,software de sistema,devops,Active Directory,Virtual,remote,Desktop,outlook,Word,Microsoft Teams,Veeam,servicios manejados,Lugar de Trabajo Moderno,Habilitación de Nube,aplicación,administración,rrhh,multimedia,Satisfacción,Migration,migracion,tecnologías,herramientas,Cloud  productivity,Development,Devices,Windows and Devices,Aplication Integration,Integration,Small,midmarket,solutions,Cloud Platform, portal office 365 iniciar sesion, office 365 login,activador office, azure sypnapse, azure private link, power automate, azure az 900, azure sentinel, azure portal sign in,microsoft 365 business standard,microsoft 365 business basic,AWS, Amazon Web Services ",
        },
      ],
    };
  },
  components: {
    Navbar,
    Preloader,
  },
  data() {
    return {
      imageSlider: null,
      cardSlider: null,
      navOffsetTop: 0,
      isLoading: false,
      siteInfo: {
        logoUrl: null,
        navLinks: {},
      },
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    document.querySelectorAll("a.page-scroll").forEach((element) => {
      element.removeEventListener("click");
    });
  },
  mounted() {
    this.getSiteInfo();

    document.querySelectorAll("a.page-scroll").forEach((element) => {
      element.addEventListener("click", (event) => {
        var clikedElement = event.target;
        var scrollDirection =
          document.scrollingElement.scrollTop >
          document.querySelector(clikedElement.attributes.href.value).offsetTop
            ? "top"
            : "bottom";

        var scrollAmount = Math.abs(
          document.scrollingElement.scrollTop -
            document.querySelector(clikedElement.attributes.href.value)
              .offsetTop
        );
        this.scrollToElement(scrollDirection, scrollAmount);
      });
    });

    let linkedInConfig = document.createElement("script");
    linkedInConfig.text = `
      _linkedin_partner_id = "2328778";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
     window._linkedin_data_partner_ids.push(_linkedin_partner_id);
     `;
    document.head.appendChild(linkedInConfig);

    let linkedIn = document.createElement("script");
    linkedIn.setAttribute(
      "src",
      "https://snap.licdn.com/li.lms-analytics/insight.min.js"
    );
    linkedIn.async = true;
    document.head.appendChild(linkedIn);
  },
  methods: {
    handleScroll(event) {
      this.navOffsetTop = event.target.scrollingElement.scrollTop;
    },
    scrollToElement(direction, amount) {
      easyScroll({
        scrollableDomEle: document.querySelector("html"),
        direction: direction,
        duration: 600,
        easingPreset: "easeOutCubic",
        scrollAmount: amount,
      });
    },
    getSiteInfo() {
      this.isLoading = true;
      try {
        fetch("./siteInfo.json")
          .then((response) => response.json())
          .then((data) => {
            this.siteInfo.logoUrl = data.logoUrl;
            this.siteInfo.navLinks = data.navLinks;
          });
      } catch (e) {
        console.log(e);
      } finally {
        setTimeout(() => (this.isLoading = false), 500);
      }
    },
  },
};
</script>


<style src="@/assets/styles/main.css"></style>

<style>
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<style>
@import url("https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,400;0,700;1,400;1,700&display=swap");
</style>
